import axios from "axios";

export default function UserCompaniesService(userId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/user/" + userId + "/companies",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
